/**
 * Firebase web config + Web Push VAPID public key for the BUILD/LOG project
 * (`buildlog-e3dae`).
 *
 * These are NON-SECRET client identifiers — they ship in the browser bundle by
 * design (the API key is just a project locator, not an auth secret). The only
 * secret is the server-side service-account JSON, which lives in an env var on
 * the backend (FCM_SERVICE_ACCOUNT_*), never here.
 *
 * The same config is handed to the messaging service worker via the
 * registration query string (see registerPush.ts) so the SW doesn't need its
 * own copy or a build-time injection step.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyD4RedJYqkN3qkU1-A0nv_2UHXw1urzgAE',
  authDomain: 'buildlog-e3dae.firebaseapp.com',
  projectId: 'buildlog-e3dae',
  storageBucket: 'buildlog-e3dae.firebasestorage.app',
  messagingSenderId: '1081673369298',
  appId: '1:1081673369298:web:0b8f853c998b3b47be4f0b',
  measurementId: 'G-FCB64072ET',
} as const

/** Web Push certificate "key pair" (public VAPID key) for getToken(). */
export const firebaseVapidKey =
  'BHsDgFZRp5Kq8CadFnHJ2uDV1DzQhnIO4xPuWHPn6GmjgiHuM8lF3GUUMtYLyx1HK90wwp_B1A94gNDBa9DkEsQ'
